import React from 'react'

const Translate = (props: any) => {
  return (
    <svg {...props} fill="none" height="100%" viewBox="0 0 48 48" width="100%" xmlns="http://www.w3.org/2000/svg">
      <path d="m0 0h48v48h-48z" fill="none" fillOpacity=".01" />
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4">
        <path d="m42 42-2.2857-5m-13.7143 5 2.2857-5m0 0 5.7143-13 5.7143 13m-11.4286 0h11.4286" />
        <path d="m16 6 1 3" />
        <path d="m6 11h22" />
        <path d="m10 16s1.7895 6.2609 6.2632 9.7391c4.4736 3.4783 11.7368 6.2609 11.7368 6.2609" />
        <path d="m24 11s-1.7895 8.2174-6.2632 12.7826c-4.4736 4.5652-11.7368 8.2174-11.7368 8.2174" />
      </g>
    </svg>
  )
}

export default Translate
